import { FC, ReactNode } from 'react';

interface BlurBackgroundImageProps {
    children: ReactNode;
    src: string;
}

const BlurBackgroundImage: FC<BlurBackgroundImageProps> = (props) => {
    const { children, src } = props;

    return (
        <div
            className="relative bg-no-repeat bg-cover bg-center h-full w-full"
            style={{ backgroundImage: `url(${src})` }}
        >
            <div className="h-full w-full bg-black/20 backdrop-blur-[100px]">
                <div className="relative h-full w-full">{children}</div>
            </div>
        </div>
    );
};

export default BlurBackgroundImage;
